module.exports = __webpack_public_path__ + "static/media/club-america.36181427.png";